import { useQuery } from '@tanstack/react-query'
import { transferServices } from '../transferServices'
import { CashbackInfoParams } from '../transferTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useGetCashbackInfo = (params: CashbackInfoParams) => {
  const result = useQuery({
    queryKey: [QUERY_KEYS.CASHBACK_INFO, params.period, params.currency],
    queryFn: async () => {
      try {
        const data = await transferServices.getCashbackInfo(params)
        return data
      } catch (error) {
        throw error
      }
    },
    enabled: !!params.period && !!params.currency,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })

  return result
}
